import { render, staticRenderFns } from "./sub.vue?vue&type=template&id=e527b0de&scoped=true&"
import script from "./sub.vue?vue&type=script&lang=js&"
export * from "./sub.vue?vue&type=script&lang=js&"
import style0 from "./sub.vue?vue&type=style&index=0&id=e527b0de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e527b0de",
  null
  
)

export default component.exports